import React, { useEffect, useState } from 'react';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { emphasize, withStyles } from '@material-ui/core/styles';
import { useAppContext } from 'hooks/useAppContext';
import { Link } from 'react-router-dom';
import Chip from '@material-ui/core/Chip';
import {
  Home, LibraryBooks
} from '@material-ui/icons';
import { Divider } from '@material-ui/core';

const StyledBreadcrumb = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.paper : theme.palette.grey[100],
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontVariant: 'all-small-caps',
    // border: '1px solid',
    fontWeight: theme.typography.fontWeightRegular,
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(theme.palette.grey[300], 0.12),
    },
  },
}))(Chip);

const AppBreadcrumbs = () => {
  const [projectName, setProjectName] = useState(null);
  const { selectedProject, currentModule, currentModuleFilter, subModule1, subModule1Filter, selectedProjectData } = useAppContext();

  useEffect(() => {
    selectedProjectData && setProjectName(selectedProjectData.ProjectName);
  }, [selectedProjectData])

  const handleClick = (event) => {
    // console.info('You clicked a breadcrumb.');
  }

  function capitalize(word) {
    return word[0].toUpperCase() + word.slice(1).toLowerCase();
  }
  return selectedProject &&
    <>
      <div style={{ padding: "0px 0px 16px 8px", marginTop: -8 }}>
        <Breadcrumbs aria-label="breadcrumb" >
          <StyledBreadcrumb
            component={Link}
            to='/projects'
            label={"Projects"}
            icon={<Home fontSize="small" />}
            onClick={handleClick}
          />
          {
            selectedProject &&
            <StyledBreadcrumb
              component={Link}
              to={`/projects/${selectedProject}/Details`}
              label={projectName ? projectName : '-------'}
              icon={<LibraryBooks fontSize="small" />}
              onClick={handleClick}
            />
          }
          {
            currentModule &&
            <StyledBreadcrumb
              component={Link}
              to={`/projects/${selectedProject}/${currentModule}`}
              label={capitalize(currentModule)}
              onClick={handleClick}
              selected
            />
          }
          {
            currentModuleFilter &&
            <StyledBreadcrumb
              component={Link}
              to={`/projects/${selectedProject}/${currentModule}/${currentModuleFilter}`}
              label={currentModuleFilter}
              onClick={handleClick}
              selected
            />
          }
          {
            subModule1 &&
            <StyledBreadcrumb
              component={Link}
              to={`/projects/${selectedProject}/${currentModule}/${currentModuleFilter}/${subModule1}`}
              label={subModule1}
              onClick={handleClick}
              selected
            />
          }
          {
            subModule1Filter &&
            <StyledBreadcrumb
              component={Link}
              to={`/projects/${selectedProject}/${currentModule}/${currentModuleFilter}/${subModule1}/${subModule1Filter}`}
              label={subModule1Filter}
              onClick={handleClick}
              selected
            />
          }
        </Breadcrumbs>
      </div>
      <Divider style={{ marginBottom: 16 }}></Divider>
    </>
};

export default AppBreadcrumbs;
export { StyledBreadcrumb };